export const siteLanguagesEng = 'en';
export const siteLanguagesPt = 'pt';
export const globalErrorMsgEng = 'Please correct the errors below.';
export const globalErrorMsgPt = ' Favor corrigir os campos abaixo';
